/**
 * @author Yaochao
 * @date 2022/4/26 20:22
 * @description
 */
import React from 'react'

const ZKSideTabAdd = (props) => {
    return props.children
};

ZKSideTabAdd.defaultProps = {
    typeName: 'ZKSideTabAdd'
};

export default ZKSideTabAdd